<template>
  <div>
    <h6 class="q-pl-md q-ma-xs">
      Bình luận:
    </h6>
    <q-list>
      <q-item>
        <q-item-section
          v-show="!isPosting"
          top
          avatar
          class="text-center q-pt-md"
        >
          <q-avatar>
            <img :src="user && user.photoURL ? user.photoURL : myimg">
          </q-avatar>
        </q-item-section>
        <q-item-section v-if="!isPosting">
          <div class="column">
            <div class="col">
              <ValidationObserver
                :ref="`${_uid}-observer`"
                tag="form"
                :data-vv-scope="`${_uid}-comment`"
              >
                <input
                  ref="fileChoose"
                  type="file"
                  style="display: none"
                  data-max-size="1024"
                  :accept="acceptFileType.join(',')"
                  @input="chooseFile"
                >
                <q-input
                  ref="comment"
                  v-model="commentBody"
                  v-validate="'required'"
                  data-vv-validate-on="input|blur|submitEvent"
                  bottom-slots
                  name="comment"
                  :error-message="errors.first(`${_uid}-comment.comment`) || errors.first(`${_uid}-comment.fileSize`)"
                  :error="errors.has(`${_uid}-comment.comment`) || errors.has(`${_uid}-comment.fileSize`)"
                  class="col q-mb-lg"
                  autogrow
                  label="Thêm một bình luận..."
                  @blur="onBlur"
                  @focus="focusInput"
                >
                  <template v-slot:append>
                    <q-chip
                      v-model="fileChip"
                      :class="{'overflow-hidden-chip' : $q.screen.xs}"
                      removable
                      color="primary"
                      text-color="white"
                      icon="attach_file"
                      @remove="removeFile"
                    >
                      {{ file ? file.name : '' }}
                    </q-chip>
                    <q-icon
                      name="attach_file"
                      @click="$refs.fileChoose.click()"
                    />
                  </template>
                </q-input>
              </ValidationObserver>
            </div>
            <div
              v-show="showButtonGroup"
              class="col q-mt-md"
            >
              <div class="row justify-end">
                <q-btn
                  label="Hủy"
                  class="q-ma-xs"
                  unelevated
                  @click="cancel"
                />
                <q-btn
                  label="Đăng bình luận"
                  color="red-4"
                  class="q-ma-xs"
                  unelevated
                  :disable="errors.has(`${_uid}-comment.comment`) || errors.has(`${_uid}-comment.fileSize`)"
                  @click="submitComment"
                />
              </div>
            </div>
          </div>
        </q-item-section>
        <q-inner-loading :showing="isPosting">
          <q-spinner
            color="red-4"
            size="3em"
            :thickness="2"
          />
        </q-inner-loading>
      </q-item>
    </q-list>
    <q-infinite-scroll
      :offset="0"
      @load="onLoadMore"
    >
      <q-list
        :key="listCommentKey"
        padding
      >
        <q-item
          v-for="(item, index) in commentList"
          :key="index"
        >
          <q-item-section
            top
            avatar
          >
            <q-avatar>
              <img :src="_.get(item, ['user','photoURL']) ? item.user.photoURL : myimg">
            </q-avatar>
          </q-item-section>

          <q-item-section>
            <q-item-label lines="1">
              <span class="text-weight-medium">{{ _.get(item,['user', 'displayName']) ? item.user.displayName : item.user.email }}</span>
              <span class="text-grey-8">- {{ getTimeFromNow(item.postTime ? item.postTime.toDate() : '') }}</span>
            </q-item-label>
            <q-item-label>
              <template v-if="typeof item.commentBody === 'object'">
                <div v-if="item.commentBody.header">
                  {{ item.commentBody.header }}
                </div>
                <div
                  v-if="item.commentBody.add"
                  class="text-green"
                >
                  <i>Cập nhật</i>
                  <div v-html="item.commentBody.add" />
                </div>
                <div
                  v-if="item.commentBody.remove"
                  class="text-red"
                >
                  <i>Xóa</i>
                  <div v-html="item.commentBody.remove" />
                </div>
              </template>
              <template v-else>
                {{ item.commentBody }}
              </template>
            </q-item-label>
            <q-item-label v-if="item.attachFileName">
              <q-separator />
              <q-btn
                flat
                icon="get_app"
                :label="item.attachFileName"
                @click="downloadItem(item.attachLocation)"
              />
            </q-item-label>
          </q-item-section>

          <q-item-section
            v-if="false"
            side
            top
          >
            <q-btn
              v-show="user.email === item.user.email"
              flat
              round
              icon="more_vert"
            >
              <q-menu
                transition-show="jump-down"
                transition-hide="jump-up"
              >
                <q-list style="min-width: 100px">
                  <q-item clickable>
                    <q-item-section
                      v-close-popup
                      @click="removeComment(item)"
                    >
                      Xóa
                    </q-item-section>
                  </q-item>
                </q-list>
              </q-menu>
            </q-btn>
          </q-item-section>
        </q-item>
      </q-list>
      <template v-slot:loading>
        <div class="row justify-center q-my-md">
          <q-spinner
            color="red-4"
            size="40px"
          />
        </div>
      </template>
    </q-infinite-scroll>
  </div>
</template>
<script>
import myimg from '@/assets/logo.png'
import moment from 'moment'
import 'moment/locale/vi'
import { firebase } from '@firebase/app'
import '@firebase/firestore'
export default {
  props: {
    user: {
      type: Object,
      default: () => {}
    },
    dataPath: {
      type: String,
      default: undefined
    }
  },
  data () {
    return {
      myimg: myimg,
      commentBody: null,
      showButtonGroup: false,
      commentList: [],
      file: null,
      fileChip: false,
      fileBase64: null,
      dataComment: {},
      acceptFileType: [
        '.pdf',
        '.doc',
        '.docx',
        '.xls',
        '.xlsx',
        '.txt',
        '.csv',
        'image/*',
        'ppt',
        'pptx'
      ],
      isPosting: false,
      listCommentKey: 0,
      currentDocArchive: null
    }
  },
  async created () {
    await this.fetchData()
  },
  methods: {
    focusInput () {
      this.showButtonGroup = true
    },
    async fetchData () {
      let splitedPath = this.dataPath.split('/')
      let res = await this.$query(
        ['Comment'],
        [['type', '==', splitedPath[0]], ['id', '==', splitedPath[1]]]
      )
      this.commentList =
        res.data && res.data.length > 0 && res.data[0].comments.messages
          ? res.data[0].comments.messages
          : []
      this.dataComment = res.data && res.data.length > 0 ? res.data[0] : {}
      this.currentDocArchive = this.dataComment ? this.dataComment.comments : null
    },
    cancel () {
      this.comment = ''
      this.showButtonGroup = false
      this.errors.clear()
    },
    async chooseFile (evt) {
      this.file = evt.target.files[0]
      this.fileChip = true
      this.fileBase64 = await this.getBase64(this.file)
    },
    getBase64 (file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => {
          let encoded = reader.result.replace(/^data:(.*;base64,)?/, '')
          if (encoded.length % 4 > 0) {
            encoded += '='.repeat(4 - (encoded.length % 4))
          }
          resolve(encoded)
        }
        reader.onerror = error => reject(error)
      })
    },
    getTimeFromNow (date) {
      moment.locale('vn')
      return moment(date).fromNow()
    },
    onBlur () {},
    async onLoadMore (index, done) {
      if (!this.dataComment || !this.dataComment._id || !this.currentDocArchive) {
        done()
        return
      }
      let refArray = ['Comment', this.dataComment._id, 'archive']
      let newArchive = this.currentDocArchive.next
      if (newArchive === null) {
        done()
        return
      }
      try {
        refArray.push(newArchive)
        await this.$query(refArray).then(res => {
          this.currentDocArchive = res && res.error ? null : res
          this.commentList = this.currentDocArchive && this.currentDocArchive.messages ? this.commentList.concat(this.currentDocArchive.messages) : this.commentList
        })
      } catch (error) {
        this.currentDocArchive = null
      } finally {
        done()
      }
    },
    removeFile () {
      this.file = null
      this.$refs.fileChoose.value = null
      this.fileBase64 = null
      this.errors.removeById('fileSize')
    },
    validate () {
      this.$refs.comment.$emit('submitEvent')
      if (this.file && this.file.size > 1000000) {
        this.errors.add({
          field: 'fileSize',
          msg: 'Max file size is 1MB',
          id: 'fileSize',
          scope: `${this._uid}-comment`
        })
        return false
      } else {
        this.errors.removeById('fileSize')
      }
      return this._.isEmpty(this.errors.items.filter(item => item.scope === `${this._uid}-comment`))
    },
    async submitComment () {
      if (!this.validate()) return
      let payload = { data: {} }
      let splitedPath = this.dataPath.split('/')
      if (this._.isEmpty(this.dataComment)) {
        payload.id = null
        payload.data.type = splitedPath[0]
        payload.data.id = splitedPath[1]
      } else {
        payload.id = this.dataComment._id
        payload.data.id = this.dataComment.id
        payload.data.type = this.dataComment.type
      }
      payload.data.comments = {
        user: {
          displayName: this.user.displayName,
          email: this.user.email,
          photoURL: this.user.photoURL
        },
        postTime: firebase.firestore.Timestamp.fromDate(
          new Date(moment.utc().format())
        ),
        commentBody: this.commentBody,
        attachFile: this.fileBase64 ? this.fileBase64 : null,
        attachFileName: this.file ? this.file.name : null,
        attachFileExt: this.file ? this.file.type : null
      }
      try {
        this.isPosting = true
        if (this._.get(payload,['data','id'])) {
          await this.$command.execute('updateComment', payload)
          await this.fetchData()
          this.resetData()
          this.$q.notify({
            message: 'Bình luận đã đăng thành công',
            color: 'black',
            icon: 'error'
          })
        } else {
          throw Error('Công việc không tồn tại, lưu công việc sau đó thử lại')
        }
      } catch (error) {
        this.$q.notify({
          message: error.message,
          color: 'red',
          icon: 'error'
        })
      }
      this.isPosting = false
    },
    async removeComment (item) {
      let payload = { data: {} }
      payload.id = this.dataComment._id
      payload.data.id = this.dataComment.id
      payload.data.type = this.dataComment.type
      payload.data.comments = item
      await this.$command.execute('deleteComment', payload)
    },
    getWindow () {
      return window
    },
    resetData () {
      this.commentBody = null
      this.file = null
      this.fileBase64 = null
      this.fileChip = false
      this.showButtonGroup = false
      this.errors.clear()
    },
    async downloadItem (loc) {
      window.open(await this.$storage.ref(loc).getDownloadURL())
    }
  }
}
</script>
<style scoped>
.overflow-hidden-chip {
  text-overflow: ellipsis !important;
  overflow: hidden !important;
  white-space: nowrap !important;
  width: 30vw;
}
</style>
